import { Indicator as IndicatorType } from '../Blocks/IndicatorHeader/indicators';
import cx from 'classnames';
import { defineMessages, useIntl } from 'react-intl';

type Props = {
  indicator: IndicatorType;
  vertical?: boolean;
  dark?: boolean;
};

// Define translatable messages
const messages = defineMessages({
  Tomorrow: {
    id: 'Tomorrow',
    defaultMessage: 'Tomorrow:',
  },
  noStatus: {
    id: 'no status',
    defaultMessage: 'no status',
  },
});
const indicatorStates = {
  default: {
    uitstekend: 'uitstekend',
    'zeer goed': 'zeer goed',
    goed: 'goed',
    'vrij goed': 'vrij goed',
    middelmatig: 'middelmatig',
    ondermaats: 'ondermaats',
    'vrij slecht': 'vrij slecht',
    slecht: 'slecht',
    'zeer slecht': 'zeer slecht',
    'uitermate slecht': 'uitermate slecht',
    normaal: 'normaal',
    prewaak: 'prewaak',
    waak: 'waak',
    alarm: 'alarm',
  },
  en: {
    uitstekend: 'excellent',
    'zeer goed': 'very good',
    goed: 'good',
    'vrij goed': 'fairly good',
    middelmatig: 'moderate',
    ondermaats: 'poor',
    'vrij slecht': 'very poor',
    slecht: 'bad',
    'zeer slecht': 'very bad',
    'uitermate slecht': 'horrible',
    normaal: 'normal',
    prewaak: 'pre-alert',
    waak: 'alert',
    alarm: 'alarm',
  },
};

export const Indicator = ({ dark, indicator, vertical }: Props) => {
  const intl = useIntl();

  const classNames = cx('indicator', {
    'indicator--vertical': vertical,
    'indicator--dark': dark,
  });

  return (
    <div className={classNames}>
      <p className="indicator__name">
        {intl.locale === 'en' ? indicator.nameEN : indicator.name}
      </p>
      <a
        className="indicator__link"
        href={intl.locale === 'en' ? indicator.hrefEN : indicator.href}
        alt={indicator.name}
      >
        <div className="indicator__content">
          <img
            className={['indicator__icon', !dark && 'indicator__icon--light']
              .filter(Boolean)
              .join(' ')}
            alt={intl.locale === 'en' ? indicator.nameEN : indicator.name}
            src={indicator.icon || undefined}
          />
          <div>
            <p className="indicator__status">
              <span
                className="indicator__status-color"
                style={{ background: indicator.color || 'rgba(0, 0, 0, .3)' }}
              />
              {(intl.locale === 'en'
                ? indicatorStates.en[indicator.status?.toLowerCase()]
                : indicatorStates.default[indicator.status?.toLowerCase()]) ||
                intl.formatMessage(messages.noStatus)}
            </p>
            {indicator.futureStatus && (
              <p className="indicator__future-status">
                <span>{intl.formatMessage(messages.Tomorrow)}</span>{' '}
                {(intl.locale === 'en'
                  ? indicatorStates.en[indicator.futureStatus?.toLowerCase()]
                  : indicatorStates.default[
                      indicator.futureStatus?.toLowerCase()
                    ]) || intl.formatMessage(messages.noStatus)}
              </p>
            )}
          </div>
        </div>
      </a>
    </div>
  );
};
